import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

@Component({
  standalone: true,
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
  imports: [CommonModule, CeIconComponent],
})
export class ButtonsComponent {
  constructor() {}

  @Output()
  btnClick = new EventEmitter();

  @Input()
  State: 'default' | 'inactive' | 'focused' | 'success' | 'alert' = 'default';

  @Input()
  active = true;

  @Input()
  success = false;

  @Input({ transform: booleanAttribute })
  shortcutKey = false;

  @Input()
  alert = false;

  @Input()
  disabled: boolean | undefined = false;

  @Input()
  loading: boolean | undefined = false;

  @Input()
  label = 'Button';

  @Input()
  keyName = '';

  @Input()
  type: 'button' | 'submit' = 'button';

  @Input()
  IconType: any = '';

  @Input()
  size: 'small' | 'large' = 'small';

  @Input()
  Type: any = '';

  click() {
    this.btnClick.emit();
  }
}
